
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MailTemplateModel } from 'models/generated/Communication.Api.Models.MailTemplate';


const _communication_EmailControllerHelper = new Map<string, Object>();
_communication_EmailControllerHelper.set('GetMailTemplates', MailTemplateModel);
_communication_EmailControllerHelper.set('GetMailTemplate', MailTemplateModel);
_communication_EmailControllerHelper.set('SaveMailTemplate', MailTemplateModel);


export const communication_EmailControllerHelper = _communication_EmailControllerHelper;

